
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js"

// Constants
import { STATUS_CODES, PUPPY_SELL_STATUS } from "@/app/constants/constants"

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js"
import { numberFormatMixins } from "@/app/mixins/modules/number-format-mixins"
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { imageUploadMixins } from "@/app/mixins/utils/image-upload-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"

export default {
	name: "BreederPuppyListComponent",
	components: {},
	mixins: [toastMessageMixins, numberFormatMixins, tableMixins, imageUploadMixins, dateMixins],
	data() {
		return {
			isAPILoading: false,
			breederNotes: "",
			isBreederAvailable: false,
			isDetailsUpdated: false,
			backButtonLabel: this.backButtonTitle,
			tableContent: {},
			breederSysId: this.breederId,
			// table
			theads: [
				{
					name: "SKU",
					searchLabel: "f_sku",
					sortLabel: "sku",
					isDesc: false,
					hasSearch: true,
					style: "width: 350px",
				},
				{
					name: "Image",
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: null,
				},
				{
					name: "Puppy Name",
					searchLabel: "f_puppyName",
					sortLabel: "puppyName",
					isDesc: false,
					hasSearch: true,
					style: "width: 230px",
				},
				{
					name: "Breed",
					searchLabel: "f_breedName",
					sortLabel: "breedName",
					isDesc: false,
					hasSearch: false,
					style: null,
				},
				{
					name: "Price",
					searchLabel: "f_price",
					sortLabel: "price",
					isDesc: false,
					hasSearch: false,
					style: null,
				},
				{
					name: "Status",
					searchLabel: "f_status",
					sortLabel: "status",
					isDesc: false,
					hasStatusSearch: true,
					style: null,
				},
				{
					name: null,
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: "max-width: 230px",
				},
			],
			filterValues:{}
		}
	},

	created() {
		this.loadSavedFilters()
        this.getTableContent(); 
    },
    activated() {
		this.loadSavedFilters()
        this.getTableContent();
	},
	methods: {
		handleClick(puppy) {
			this.saveAllFilters()
			const savedTabId = localStorage.getItem('selectedTab');
			if (!savedTabId) {
				localStorage.setItem('selectedTab', 'puppylist');
			} 
			this.$router.push({
				path: `/pet-purchases/puppy-selling/${puppy.id}/view`,
				query: {
				fromBreeder: true,
			}
			});
        },
		onColumnDataFilter(filterBy, event) {
			if (filterBy) {
			  this.page = 1;
					  this.columnsFilter[filterBy] = event.target.value;
					  this.filterValues[filterBy] = event.target.value;
			  this.delayTyping(() => {
				this.getTableContent(false, this.page, this.limit, this.sortBy, this.desc);
			  });
			}
		  },
		  loadSavedFilters() {
            const filters = this.$store.state.breederPuppyListFilters.filters;
            const hasFilters = filters && Object.keys(filters).length > 0;
			if (hasFilters) {
				this.page = this.$store.getters.getPuppyListFilters('page') || 1;
				this.limit = this.$store.getters.getPuppyListFilters('limit') || 10; 
				this.sortBy = this.$store.getters.getPuppyListFilters('sortBy') || '';
				this.desc = this.$store.getters.getPuppyListFilters('isDesc'); 
                // You can access the saved filter values from the store like this:
                this.theads.forEach(th => {
					if(this.sortBy === th.sortLabel) {
						th.isDesc =  this.desc
					}
                    const savedFilter = this.$store.getters.getPuppyListFilters(th.sortLabel);
                    if (savedFilter) {
                        this.columnsFilter[th.searchLabel] = savedFilter;
                        this.filterValues[th.searchLabel] = savedFilter
                    }
                }); 
                this.clearFilters()
            }
        },  
		clearFilters() {
            const filters = this.$store.state.breederPuppyListFilters.filters;
            const hasFilters = filters && Object.keys(filters).length > 0; 
            if (hasFilters) {
                this.$store.dispatch('resetPuppyListFilters');
            }
        },
		saveAllFilters() {
			const filters = {};
			// Collect all the column filter values
			this.theads.forEach(th => {
				const searchInput = this.columnsFilter[`${th.searchLabel}`];
				if (searchInput) {
					filters[th.sortLabel] = searchInput;
				}
			});

			// Add pagination details to filters
			filters.page = this.page; // current page
			filters.limit = this.limit; // items per page
			filters.sortBy = this.sortBy;
			filters.isDesc = this.desc; 
			// Dispatch all filters, including pagination, to Vuex store
			Object.keys(filters).forEach(label => {
				this.$store.dispatch('applyPuppyListFilter', { label, value: filters[label] });
			});
		},

		hasProductImage(productImage) {
			let image = require("@/assets/images/temporary/product-image.png")

			if (productImage) {
				image = productImage
			}

			return image
		},

		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page
			this.getPuppySellList({ page, limit, sortBy, desc })
		},
		getPuppySellList(queryParams) {
			// search filters
			if (this.columnsFilter) {
				const { f_status, f_sku, f_puppyName } = this.columnsFilter

				queryParams["f_breederSysId"] = this.$route.params.id

				if (f_status) {
					queryParams["f_status"] = f_status
				}

				if (f_sku) {
					queryParams["f_sku"] = f_sku
				}

				if (f_puppyName) {
					queryParams["f_puppyName"] = f_puppyName
				}
			}

			this.isAPILoading = true

			puppySellService.getPuppySellList(queryParams).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.tableContent = {
						tableData: res.data.data.map((dt) => {
							return { ...dt, status: PUPPY_SELL_STATUS[dt.status] === 'HIDE' ? dt.status : PUPPY_SELL_STATUS[dt.status] }
						}),
						paginationData: res.data.pagination,
					}

					this.isAPILoading = false
				} else {
					this.showAPIErrorToast("Unable to fetch puppy sell list.", res)
					this.isAPILoading = false
				}
			})
		},


		deletePuppy(puppySellId) {
			this.$swal({
				titleText: `Delete Puppy`,
				html: `<p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>Are you sure you want to delete this puppy?</p>`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				showCloseButton: true
			}).then((result) => {
				if (result.value) {
					this.isAPILoading = true

					puppySellService.putDeletePuppyToSell(puppySellId).then((response) => {
						if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.getTableContent()
							this.showCustomSuccessToast(`Successfully deleted this puppy.`)
						} else {
							this.showAPIErrorToast(response.data.errors[0].message, response)
						}
						this.isAPILoading = false
					})
				}
			})
		},




	},
}
